// filepath: src/store/slices/userActions.js
import apiClient from "../services/apiClient";
import { slice } from "./user";

const ep = (p) => p;
const getId = (v) => (v && typeof v === "object" ? (v.id ?? v) : v);
const playerBalanceRequestMap = new Map();

const toFiniteNumber = (value) => {
  if (value === undefined || value === null || value === "") return null;
  const num = typeof value === "string" ? Number(value) : value;
  return Number.isFinite(num) ? num : null;
};

const normalizeMeta = (rawMeta, params, data, responseData) => {
  const meta =
    rawMeta && typeof rawMeta === "object" && !Array.isArray(rawMeta)
      ? { ...rawMeta }
      : {};
  const paramBag = params || {};

  if (meta.page == null && meta.pageNumber != null) {
    const pageNumber = toFiniteNumber(meta.pageNumber);
    if (pageNumber != null) meta.page = pageNumber;
  }
  if (meta.page == null) {
    const pageFromParams = toFiniteNumber(paramBag.page);
    if (pageFromParams != null) meta.page = pageFromParams;
  }
  if (meta.page == null) meta.page = 1;

  const limitSources = [
    meta.limit,
    meta.pageSize,
    meta.perPage,
    meta.page_length,
    paramBag.limit,
  ];
  for (const candidate of limitSources) {
    const parsed = toFiniteNumber(candidate);
    if (parsed != null) {
      meta.limit = parsed;
      break;
    }
  }
  if (meta.limit == null && Array.isArray(data)) {
    meta.limit = data.length;
  }

  const totalSources = [
    meta.total,
    meta.totalCount,
    meta.count,
    meta.totalRecords,
    meta.totalItems,
    meta.recordsTotal,
    responseData?.total,
    responseData?.totalCount,
    responseData?.count,
    responseData?.totalRecords,
    responseData?.totalItems,
    responseData?.recordsTotal,
  ];
  for (const candidate of totalSources) {
    const parsed = toFiniteNumber(candidate);
    if (parsed != null) {
      meta.total = parsed;
      break;
    }
  }
  if (meta.total == null && Array.isArray(data)) {
    meta.total = data.length;
  }

  return meta;
};

export const getColorSettings = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/setting/colorsetting"));
    dispatch(slice.actions.getColorSettingsSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getAllRankingHistoryByID = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(
      ep(`/ranking/getrankhistorybyid/${getId(id)}`),
    );
    dispatch(slice.actions.getAllRankingHistoryByIDSuccess(r.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getAllRanking = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/ranking"));
    dispatch(slice.actions.getAllRankingSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getWheelSetting = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/setting/wheelsetting"));
    dispatch(slice.actions.getWheelSettingSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getWheelPoint = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(ep(`/wheel/point/${getId(id)}`));

    dispatch(slice.actions.getWheelPointSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getGameListUrl = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/gamelogin/getgamelist"));
    dispatch(slice.actions.getGameListUrlSuccess(r.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getAllProvider = (id) => async (dispatch) => {
  try {
    const r = await apiClient.post(ep(`/gamelogin/getprovider/${getId(id)}`));
    dispatch(
      slice.actions.getAllProviderSuccess(
        r.data.providers || r.data.providerList || [],
      ),
    );
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getFriendInvite = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(
      ep(`/agentbalance/invitesummaryclient/${getId(id)}`),
    );
    dispatch(slice.actions.getFriendInviteSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getUserAvailablePromotion = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(
      ep(`/usersystem/getavailablepromotion/${getId(id)}`),
    );
    dispatch(slice.actions.getUserAvailablePromotionSuccess(r.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getWithdrawSetting = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/setting/withdraw"));
    dispatch(slice.actions.getWithdrawSettingSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};

export const getMarketingActivitiesActive = (userId) => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/marketing-activity/active"), {
      params: { userId },
    });
    dispatch(slice.actions.setMarketingActivitiesActive(r.data?.data || []));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};

export const submitMarketingActivity =
  (activityId, payload) => async (dispatch) => {
    try {
      const r = await apiClient.post(
        ep(`/marketing-activity/${activityId}/submit`),
        payload,
      );
      dispatch(slice.actions.setMarketingSubmitResult(r.data));
      await dispatch(getMarketingActivitiesActive(payload?.userId));
    } catch (e) {
      dispatch(slice.actions.hasError(e));
      throw e;
    }
  };
export const getBankList = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/bank"));
    dispatch(slice.actions.getBankListSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getTranferBankList = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/8hwe8vhevv/banklist"));
    dispatch(slice.actions.getTransferBankListSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getTodayPromotionReceived = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(
      ep(`/usersystem/checkreceivedpromotion/${getId(id)}`),
    );
    dispatch(slice.actions.getTodayPromotionReceivedSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getAllPromotionReceived = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(
      ep(`/usersystem/checkallreceivedpromotion/${getId(id)}`),
    );
    dispatch(slice.actions.getAllPromotionReceivedSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getBannerList = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/setting/banner"));
    dispatch(slice.actions.getBannerListSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getPopupList = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/setting/popup"));
    dispatch(slice.actions.getAllPopupSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getWebsiteSetting = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/setting/websetting"));
    dispatch(slice.actions.getWebsiteSettingSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getTMNData = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/bank/tmnfront"));
    dispatch(slice.actions.getTMNDataSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getPlayerLoginLink = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(ep(`/gamelogin/getlogin/${getId(id)}`));
    dispatch(slice.actions.getPlayerLoginLinkSuccess(r.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getTransactionHistory = (options) => async (dispatch) => {
  try {
    const args =
      options && typeof options === "object" && !Array.isArray(options)
        ? options
        : {};
    const idCandidate = getId(options);
    if (
      idCandidate === undefined ||
      idCandidate === null ||
      idCandidate === ""
    ) {
      dispatch(
        slice.actions.getTransactionHistorySuccess({ data: [], meta: null }),
      );
      return;
    }

    const params = {};
    if (args.page != null) params.page = args.page;
    if (args.limit != null) params.limit = args.limit;
    if (typeof args.type === "string" && args.type.trim())
      params.type = args.type.trim();
    if (typeof args.sort === "string" && args.sort.trim())
      params.sort = args.sort.trim();
    if (typeof args.order === "string" && args.order.trim())
      params.order = args.order.trim();
    if (args.status != null) params.status = args.status;

    const response = await apiClient.get(
      ep(`/userbalance/history/${idCandidate}`),
      Object.keys(params).length ? { params } : undefined,
    );

    const data = Array.isArray(response?.data?.data) ? response.data.data : [];
    const meta = normalizeMeta(
      response?.data?.meta || response?.data?.pagination || null,
      params,
      data,
      response?.data,
    );

    dispatch(
      slice.actions.getTransactionHistorySuccess({
        data,
        meta,
      }),
    );
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getWithdrawHistory = (options) => async (dispatch) => {
  try {
    const args =
      options && typeof options === "object" && !Array.isArray(options)
        ? options
        : {};
    const idCandidate = getId(options);
    if (
      idCandidate === undefined ||
      idCandidate === null ||
      idCandidate === ""
    ) {
      dispatch(
        slice.actions.getWithdrawHistorySuccess({ data: [], meta: null }),
      );
      return;
    }

    const params = {};
    if (args.page != null) params.page = args.page;
    if (args.limit != null) params.limit = args.limit;
    if (typeof args.sort === "string" && args.sort.trim())
      params.sort = args.sort.trim();
    if (typeof args.order === "string" && args.order.trim())
      params.order = args.order.trim();
    if (args.status != null) params.status = args.status;

    const response = await apiClient.get(
      ep(`/userbalance/withdrawhistory/${idCandidate}`),
      Object.keys(params).length ? { params } : undefined,
    );

    const data = Array.isArray(response?.data?.data) ? response.data.data : [];
    const meta = normalizeMeta(
      response?.data?.meta || response?.data?.pagination || null,
      params,
      data,
      response?.data,
    );

    dispatch(
      slice.actions.getWithdrawHistorySuccess({
        data,
        meta,
      }),
    );
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getPlayerBalance = (id) => async (dispatch) => {
  const resolvedId = getId(id);

  if (!resolvedId) {
    return;
  }

  try {
    let requestPromise = playerBalanceRequestMap.get(resolvedId);

    if (!requestPromise) {
      requestPromise = apiClient
        .get(ep(`/userbalance/balance/${resolvedId}`))
        .finally(() => {
          playerBalanceRequestMap.delete(resolvedId);
        });

      playerBalanceRequestMap.set(resolvedId, requestPromise);
    }

    const r = await requestPromise;
    dispatch(slice.actions.getPlayerBalanceSuccess(r.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getPlayerCash = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(ep(`/userbalance/cash/${getId(id)}`));
    dispatch(slice.actions.getPlayerCashSuccess(r?.data?.cashWallet));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getBetflixStatus = () => async (dispatch) => {
  try {
    const r = await apiClient.get("https://api.bfx.fail/v4/status");
    dispatch(slice.actions.getBetflixStatusSuccess(r.data.status));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getAllPromo = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/promotion/getavailable"));
    dispatch(slice.actions.getAllPromoSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getCashbackSetting = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/setting/cashback"));
    dispatch(slice.actions.getCashbackSettingSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getCashback = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(
      ep(`/agentbalance/cashbackclientcheck/${getId(id)}`),
    );
    dispatch(slice.actions.getCashbackSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getInviteSetting = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/setting/invite"));
    dispatch(slice.actions.getInviteSettingSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getAgentInfo = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/agentinfo"));
    dispatch(slice.actions.getAgentInfoSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getAgentBalance = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/agentbalance"));
    dispatch(slice.actions.getAgentBalanceSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getPromoByID = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(ep(`/promotion/getbyid/${getId(id)}`));
    dispatch(slice.actions.getPromoByIDSuccess(r?.data?.data[0]));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getAllCreditCode = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/creditcode"));
    dispatch(slice.actions.getAllCreditCodeSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getCreditCodeByID = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(ep(`/creditcode/${getId(id)}`));
    dispatch(slice.actions.getCreditCodeByIDSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getUsersByID = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(ep(`/usersystem/${getId(id)}`), {
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
    });
    dispatch(slice.actions.getUsersByIDSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getAllTransactionDW = () => async (dispatch) => {
  try {
    const r = await apiClient.get(ep("/8hwe8vhevv"));
    dispatch(slice.actions.getAllTransactionDWSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};
export const getByIdTransactionDW = (id) => async (dispatch) => {
  try {
    const r = await apiClient.get(ep(`/8hwe8vhevv/${getId(id)}`));
    dispatch(slice.actions.getByIdTransactionDWSuccess(r.data.data));
  } catch (e) {
    dispatch(slice.actions.hasError(e));
  }
};

// Hot Games actions
export const getHotGames = () => async (dispatch) => {
  dispatch(slice.actions.getHotGamesRequest());
  try {
    const r = await apiClient.get(ep("/hotgames"));
    dispatch(slice.actions.getHotGamesSuccess(r.data.data || []));
  } catch (e) {
    dispatch(
      slice.actions.getHotGamesFailure(
        e.message || "Failed to fetch hot games",
      ),
    );
    dispatch(slice.actions.hasError(e));
  }
};
